module.exports = __webpack_public_path__ + "img/ax-mobile-hover.55b0a2d9.png";